import PasswordChangeView from './Change';
import PasswordChangeConfirmationView from './ChangeConfirmation';

export {
	PasswordChangeView,
	PasswordChangeConfirmationView,
};